import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb.tsx";
import {Separator} from "@/components/ui/separator";
import {SidebarTrigger} from "@/components/ui/sidebar";
import {Fragment, useMemo} from "react";
import {Link} from "react-router-dom";
import {useBreadcrumbPageTitle} from "../../routes/breadcrumb-page-title";
import {useAppBreadcrumbs} from "../../routes/breadcrumbs";
import {appRoutes} from "../../routes/app-routes";

export function PageHeader() {
	const routeCrumbs = useAppBreadcrumbs(appRoutes);
	const {title: pageTitle, trailing} = useBreadcrumbPageTitle();
	const crumbs = useMemo(() => {
		if (!pageTitle || routeCrumbs.length === 0) {
			return routeCrumbs;
		}
		if (routeCrumbs.length === 1) {
			const section = routeCrumbs[0];
			return [section, {href: section.href, label: pageTitle}];
		}
		const last = routeCrumbs[routeCrumbs.length - 1];
		return [...routeCrumbs.slice(0, -1), {...last, label: pageTitle}];
	}, [pageTitle, routeCrumbs]);

	return (
		<header
			className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-2 border-b border-border/50 bg-background/45 backdrop-blur-xl backdrop-saturate-150 transition-[width,height] ease-linear supports-[backdrop-filter]:bg-background/30 group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
			<div className="flex min-w-0 flex-1 items-center gap-2 px-4">
				<SidebarTrigger className="-ml-1"/>
				<Separator
					orientation="vertical"
					className="mr-2 data-[orientation=vertical]:h-4"
				/>
				<Breadcrumb>
					<BreadcrumbList>
						{crumbs.map((crumb, index) => {
							const isLast = index === crumbs.length - 1;

							return (
								<Fragment key={`${crumb.href}-${index}-${crumb.label}`}>
									{index > 0 && <BreadcrumbSeparator/>}

									<BreadcrumbItem>
										{isLast ? (
											<BreadcrumbPage className="max-w-[min(100vw-12rem,28rem)] truncate">
												{crumb.label}
											</BreadcrumbPage>
										) : (
											<BreadcrumbLink>
												<Link to={crumb.href}>
													{crumb.label}
												</Link>
											</BreadcrumbLink>
										)}
									</BreadcrumbItem>
								</Fragment>
							);
						})}
					</BreadcrumbList>
				</Breadcrumb>
			</div>
			{trailing ? (
				<div className="flex shrink-0 items-center gap-2 px-4">{trailing}</div>
			) : null}
		</header>
	);
}
